import 'css-chunksrc/client/pages/obsPage/styles.scss';export default {
  "obsPage": "_obsPage_k1par_1",
  "header": "_header_k1par_8",
  "profileNavigation": "_profileNavigation_k1par_18",
  "title": "_title_k1par_26",
  "main": "_main_k1par_32",
  "content": "_content_k1par_40",
  "menu": "_menu_k1par_45",
  "button": "_button_k1par_53",
  "iconBox": "_iconBox_k1par_74",
  "container": "_container_k1par_83",
  "table": "_table_k1par_91",
  "columns0": "_columns0_k1par_95",
  "columns1": "_columns1_k1par_100",
  "columns2": "_columns2_k1par_105",
  "columns3": "_columns3_k1par_110",
  "columns4": "_columns4_k1par_115",
  "columns5": "_columns5_k1par_120",
  "columns6": "_columns6_k1par_125",
  "columns7": "_columns7_k1par_130",
  "columns8": "_columns8_k1par_135",
  "columns9": "_columns9_k1par_140",
  "columns10": "_columns10_k1par_145",
  "columns11": "_columns11_k1par_150",
  "columns12": "_columns12_k1par_155",
  "columns13": "_columns13_k1par_160",
  "columns14": "_columns14_k1par_165",
  "columns15": "_columns15_k1par_170",
  "columns16": "_columns16_k1par_175",
  "columns17": "_columns17_k1par_180",
  "columns18": "_columns18_k1par_185",
  "columns19": "_columns19_k1par_190",
  "columns20": "_columns20_k1par_195",
  "columns21": "_columns21_k1par_200",
  "columns22": "_columns22_k1par_205",
  "columns23": "_columns23_k1par_210",
  "columns24": "_columns24_k1par_215",
  "columns25": "_columns25_k1par_220",
  "columns26": "_columns26_k1par_225",
  "columns27": "_columns27_k1par_230",
  "columns28": "_columns28_k1par_235",
  "columns29": "_columns29_k1par_240",
  "columns30": "_columns30_k1par_245",
  "columns31": "_columns31_k1par_250",
  "columns32": "_columns32_k1par_255",
  "columns33": "_columns33_k1par_260",
  "columns34": "_columns34_k1par_265",
  "columns35": "_columns35_k1par_270",
  "columns36": "_columns36_k1par_275",
  "columns37": "_columns37_k1par_280",
  "columns38": "_columns38_k1par_285",
  "columns39": "_columns39_k1par_290",
  "columns40": "_columns40_k1par_295"
};